import NavView from './NavView';

export default NavView;
